export enum Splits {
    GUESTS_PORTAL_MOBILE_APP = 'guests-portal-download-app-mobile',
    GUESTS_PORTAL_WEB_CHAT = 'guests-portal-web-chat',
    GUEST_PORTAL_NEW_PET_ADJUSTMENT = 'guest-portal-new-pet-adjustment',
    GUEST_PORTAL_NEW_OCCUPANCY_ADJUSTMENT = 'guest-portal-new-occupancy-adjustment',
    GUEST_PORTAL_ADD_NIGHT_RESERVATION_SERVICE = 'trip-api-add-night-through-reservation-service',
    GUEST_PORTAL_POOL_HEAT = 'guest-portal-pool-heat',
    GUESTS_PORTAL_MAINTENANCE = 'guests-portal-maintenance',
}

export interface AdjustmentConfig {
    allowedChannels: Array<number>;
}

export interface WebChatConfig {
    stateRestrictionActive: boolean;
    allowedStates: Array<string>;
}

export interface MaintenanceConfig {
    pages: Array<string>;
    full: boolean;
}

export interface FeatureDecisionResult<T> {
    isEnabled: boolean;
    config: T | null;
    clientReady: boolean;
}
